/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../../graphql/generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IInternalRiskNamesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type IInternalRiskNamesQuery = { __typename?: 'Query'; internalRiskNames: Array<string> };

export const InternalRiskNamesDocument = gql`
  query InternalRiskNames {
    internalRiskNames
  }
`;

/**
 * __useInternalRiskNamesQuery__
 *
 * To run a query within a React component, call `useInternalRiskNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalRiskNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalRiskNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useInternalRiskNamesQuery(
  baseOptions?: Apollo.QueryHookOptions<IInternalRiskNamesQuery, IInternalRiskNamesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IInternalRiskNamesQuery, IInternalRiskNamesQueryVariables>(InternalRiskNamesDocument, options);
}
export function useInternalRiskNamesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IInternalRiskNamesQuery, IInternalRiskNamesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IInternalRiskNamesQuery, IInternalRiskNamesQueryVariables>(
    InternalRiskNamesDocument,
    options,
  );
}
// @ts-ignore
export function useInternalRiskNamesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IInternalRiskNamesQuery, IInternalRiskNamesQueryVariables>,
): Apollo.UseSuspenseQueryResult<IInternalRiskNamesQuery, IInternalRiskNamesQueryVariables>;
export function useInternalRiskNamesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IInternalRiskNamesQuery, IInternalRiskNamesQueryVariables>,
): Apollo.UseSuspenseQueryResult<IInternalRiskNamesQuery | undefined, IInternalRiskNamesQueryVariables>;
export function useInternalRiskNamesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IInternalRiskNamesQuery, IInternalRiskNamesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IInternalRiskNamesQuery, IInternalRiskNamesQueryVariables>(
    InternalRiskNamesDocument,
    options,
  );
}
export type InternalRiskNamesQueryHookResult = ReturnType<typeof useInternalRiskNamesQuery>;
export type InternalRiskNamesLazyQueryHookResult = ReturnType<typeof useInternalRiskNamesLazyQuery>;
export type InternalRiskNamesSuspenseQueryHookResult = ReturnType<typeof useInternalRiskNamesSuspenseQuery>;
export type InternalRiskNamesQueryResult = Apollo.QueryResult<
  IInternalRiskNamesQuery,
  IInternalRiskNamesQueryVariables
>;
